export const DEFAULT_BRANCH_NAME = "New path";

export function nextDefaultBranchName(
  existingNames: readonly string[]
): string {
  const used = new Set(
    existingNames.map((name) => name.trim()).filter((name) => name.length > 0)
  );

  if (!used.has(DEFAULT_BRANCH_NAME)) {
    return DEFAULT_BRANCH_NAME;
  }

  let suffix = 2;
  while (used.has(`${DEFAULT_BRANCH_NAME} ${suffix}`)) {
    suffix += 1;
  }

  return `${DEFAULT_BRANCH_NAME} ${suffix}`;
}
